import queryString from 'query-string';
import {Map} from 'immutable';
import {Socket} from 'phoenix-socket';
import domready from 'domready';
import {getFromMeta} from 'utils/userToken';
import {dispatch} from 'store/jobs';
import {JOBS_JOIN_TOPIC, JOBS_TOPIC_STATE, updateJobStatusTopicState} from '../actions';

const JOB_STATUS_PROCESSING = 'processing';
const JOB_STATUS_FINISHED = 'finished';
const JOB_STATUS_ERRORED = 'errored';

let socket;

domready(() => {
  const userToken = getFromMeta();

  if (!socket && userToken) {
    socket = new Socket(FORGE_WEBSOCKET_URL, {
      params: {token: userToken},
    });

    socket.connect();
  }
});

export function jobs(state = null, action) {
  let nextState = state || Map({
    connected: false,
    channels: Map({}),
    status: Map({}),
  });

  if (action.type === JOBS_JOIN_TOPIC) {
    nextState = nextState.set('connected', !!socket);

    action.jobStatusTopics.forEach((jobStatusTopic) => {
      const channel = nextState.get('channels').has(jobStatusTopic.id) ?
        nextState.get('channels').get(jobStatusTopic.id).channel :
        socket.channel(`job:${jobStatusTopic.topic}`, {});

      nextState = nextState
        .update('status', (status) => {
          return status.set(jobStatusTopic.id, (jobStatusTopic.active) ? JOB_STATUS_PROCESSING : JOB_STATUS_FINISHED);
        });

      if (jobStatusTopic.active && channel.state === 'closed') {
        channel.join();

        channel.on('status', (payload) => {
          dispatch(updateJobStatusTopicState(jobStatusTopic.topic, payload.state));
        });
      }

      nextState = nextState
        .update('channels', (channels) => {
          return channels.set(jobStatusTopic.id, {channel, jobStatusTopic});
        });
    });
  }

  if (action.type === JOBS_TOPIC_STATE) {
    const {jobStatusTopic} = nextState.get('channels').find((channelAndJobStatusTopic) => {
      return channelAndJobStatusTopic.jobStatusTopic.topic === action.topic;
    });

    nextState = nextState.update('status', (status) => status.set(jobStatusTopic.id, action.state));
  }

  return nextState;
}



// WEBPACK FOOTER //
// ./app/javascript/reducers/jobs.js